/** Read-only event state supplied by the API, shared across event lists. */
export type EventPresentationState = {
  eventStatus?: string | null;
  lifecycle?: string | null;
  isRejected?: unknown;
  isDuplicate?: unknown;
};

/** Names, HR labels and dates never determine cancellation. */
export function isCancelledEvent(event?: EventPresentationState | null): boolean {
  return event?.lifecycle === "cancelled" || event?.eventStatus === "Cancelled" || event?.isRejected === true;
}

/** Record-state labels take precedence over the normal time/workflow label. */
export function eventRecordStateLabel(event?: EventPresentationState | null): string | null {
  if (event?.isDuplicate === true || event?.eventStatus === "Duplicate") return "Duplicate";
  if (isCancelledEvent(event)) return "Cancelled";
  return null;
}

export function eventStatusLabel(event?: EventPresentationState | null, fallback = "N/A"): string {
  return eventRecordStateLabel(event) || event?.eventStatus || fallback;
}

/** Only the event summary row is struck, leaving nested crew/payment history readable. */
export const CANCELLED_EVENT_ROW_SX = {
  '&[data-cancelled="true"]': {
    "& > td, & > td p, & > td span, & > td a, & > td input, & > td textarea": {
      textDecoration: "line-through",
    },
  },
} as const;
